<template>
  <div>
    <Structure v-if="isStructured === 1" />
    <NonStructural v-if="isStructured === 0" />
    <div class="flex-sb">
      <div>
        <eui-btn type="secondary" @click="goBack">返回</eui-btn>
      </div>
      <div>
        <eui-btn type="secondary" style="margin-right: 10px"
          >下载评价办法</eui-btn
        >
        <eui-btn type="secondary">下载评价细则</eui-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Structure from './components/detailComponents/structure.vue';
import NonStructural from './components/detailComponents/nonStructural.vue';
export default {
  data() {
    return {
      isStructured: '', // 1 是结构化
    };
  },
  components: { Structure, NonStructural },
  computed: {},
  mounted() {
    this.isStructured = Number(this.$route.query.isStructured);
  },
  methods: {
    goBack() {
      this.$router.push({
        path: '/ES/ESorganization',
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
